import { RoomV2EntityRaw } from "@common/domain";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomsListActions, RoomsPastListActions } from "../actions";

export const ROOMS_PAST_LIST_FEATURE_KEY = "roomsPastList";

export interface RoomsPastListState extends EntityState<RoomV2EntityRaw> {
  isLoading: boolean;
}

export const roomsPastListAdapter: EntityAdapter<RoomV2EntityRaw> =
  createEntityAdapter<RoomV2EntityRaw>({
    sortComparer: (lhs, rhs) => {
      if (lhs.startAt && rhs.startAt) {
        return rhs.startAt - lhs.startAt;
      }

      if (!lhs.startAt && rhs.startAt) {
        return 1;
      }

      if (lhs.startAt && !rhs.startAt) {
        return -1;
      }

      return rhs.id - lhs.id;
    }
  });

const initialState: RoomsPastListState = roomsPastListAdapter.getInitialState({
  isLoading: false
});

const reducer = createReducer(
  initialState,
  on(
    RoomsListActions.roomDelete,
    RoomsPastListActions.roomsPastList,
    (state) => {
      return {
        ...state,
        isLoading: true
      };
    }
  ),
  on(RoomsPastListActions.roomsPastListSuccess, (state, { rooms }) =>
    roomsPastListAdapter.addMany(
      rooms.map((_) => _.toJSON()),
      {
        ...state,
        isLoading: false
      }
    )
  ),
  on(
    RoomsListActions.roomDeleteFailure,
    RoomsPastListActions.roomsPastListFailure,
    (state) => {
      return {
        ...state,
        isLoading: false
      };
    }
  ),
  on(RoomsListActions.roomDeleteSuccess, (state, { roomDeleteCmd }) =>
    roomsPastListAdapter.removeOne(roomDeleteCmd.value.roomId, {
      ...state,
      isLoading: false
    })
  )
);

export function roomsPastListReducer(
  state: RoomsPastListState | undefined,
  action: Action
) {
  return reducer(state, action);
}
